import {graphql} from 'gatsby'
import React from 'react'

import useSignup, {Args as UseSignupArgs} from '@/hooks/use-signup'
import SignupBannerBase, {
    Props as SimpleSignupFormProps,
} from '@helios/shared/sections/signup-banner'
import {TextProps} from '@helios/shared/styles/typography'
import {colors} from '@helios/shared/theme'
import ImageSource from '@helios/shared/types/image'

export interface Props
    extends Pick<
        SimpleSignupFormProps,
        'placeholder' | 'submitText' | 'errorText' | 'stacked' | 'ariaLabel'
    > {
    color: keyof typeof colors.background
    title: string
    subtitle: string
    image?: ImageSource | null
    titleSize?: TextProps['size']
    signupOptions?: UseSignupArgs
}

const SignupBanner: React.FC<Props> = ({signupOptions, ...props}) => {
    const signupProps = useSignup(
        signupOptions || {
            form: 'Front',
        }
    )

    return <SignupBannerBase {...props} {...signupProps} />
}

export const signupBannerFragment = graphql`
    fragment SignupBanner on PrismicSignupBanner {
        _previewable
        type
        data {
            title
            subtitle
            email_input_placeholder
            email_input_error_text
            submit_text
            aria_label
            image {
                alt
                copyright
                url
                dimensions {
                    width
                    height
                }
            }
        }
    }
`

export default SignupBanner
